import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _Object$values from '@babel/runtime-corejs3/core-js-stable/object/values';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import classNames from 'classnames/bind';
import React, { useEffect } from 'react';
import IconText from './IconText.js';
import IcBottomNaviAssetDisabled from '../icons/IcBottomNaviAssetDisabled.js';
import IcBottomNaviAssetEnabled from '../icons/IcBottomNaviAssetEnabled.js';
import IcBottomNaviFinanceDisabled from '../icons/IcBottomNaviFinanceDisabled.js';
import IcBottomNaviFinanceEnabled from '../icons/IcBottomNaviFinanceEnabled.js';
import IcBottomNaviPayDisabled from '../icons/IcBottomNaviPayDisabled.js';
import IcBottomNaviPayEnabled from '../icons/IcBottomNaviPayEnabled.js';
import IcBottomNaviRealEstateDisabled from '../icons/IcBottomNaviRealEstateDisabled.js';
import IcBottomNaviRealEstateEnabled from '../icons/IcBottomNaviRealEstateEnabled.js';
import IcBottomNaviStockDisabled from '../icons/IcBottomNaviStockDisabled.js';
import IcBottomNaviStockEnabled from '../icons/IcBottomNaviStockEnabled.js';
import IcTxtArrowDownFill from '../icons/IcTxtArrowDownFill.js';
import '../../constants/bottomNavigationBar.js';
import '../../constants/footer.js';
import '../../constants/footerQuickMenuItem.js';
import { NF_SERVICE_TYPE, NF_SERVICE_INFO } from '../../constants/global.js';
import { BOTTOM_MODAL_NOTICE_TYPE } from '../../constants/modal.js';
import { useModal } from '../../contexts/ModalContext.js';
import COLOR from '../../foundation/color.js';
import { setToolbarPosition, restoreToolbarPosition } from '../../utils/naverApp.js';
import styles from './BottomNavigationBar.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
var ITEMS = [{
  icon: {
    disabled: /*#__PURE__*/React.createElement(IcBottomNaviAssetDisabled, {
      width: 24,
      height: 24
    }),
    enabled: /*#__PURE__*/React.createElement(IcBottomNaviAssetEnabled, {
      width: 24,
      height: 24
    })
  },
  type: NF_SERVICE_TYPE.MY_ASSET
}, {
  icon: {
    disabled: /*#__PURE__*/React.createElement(IcBottomNaviPayDisabled, {
      width: 24,
      height: 24
    }),
    enabled: /*#__PURE__*/React.createElement(IcBottomNaviPayEnabled, {
      width: 24,
      height: 24
    })
  },
  type: NF_SERVICE_TYPE.PAYMENT
}, {
  icon: {
    disabled: /*#__PURE__*/React.createElement(IcBottomNaviFinanceDisabled, {
      width: 24,
      height: 24
    }),
    enabled: /*#__PURE__*/React.createElement(IcBottomNaviFinanceEnabled, {
      width: 24,
      height: 24
    })
  },
  type: NF_SERVICE_TYPE.FINANCE
}, {
  icon: {
    disabled: /*#__PURE__*/React.createElement(IcBottomNaviStockDisabled, {
      width: 24,
      height: 24
    }),
    enabled: /*#__PURE__*/React.createElement(IcBottomNaviStockEnabled, {
      width: 24,
      height: 24
    })
  },
  type: NF_SERVICE_TYPE.STOCK
}, {
  icon: {
    disabled: /*#__PURE__*/React.createElement(IcBottomNaviRealEstateDisabled, {
      width: 24,
      height: 24
    }),
    enabled: /*#__PURE__*/React.createElement(IcBottomNaviRealEstateEnabled, {
      width: 24,
      height: 24
    })
  },
  type: NF_SERVICE_TYPE.REAL_ESTATE
}];
/**
 * 이 컴포넌트를 서비스에서 바로 사용하지 말아주세요.
 * 반드시 [@financial/defign-interface](https://oss.fin.navercorp.com/common-fe/pie/tree/main/packages/defign-interface)의 `BottomNavigationBar`를 사용하셔야 합니다.
 *
 */
function BottomNavigationBar(props) {
  var _context;
  var active = props.active;
  var _useModal = useModal(),
    isShowModal = _useModal.isShow,
    type = _useModal.type;
  // active에 의해 처리하지 않고 mount에서 처리한 이유. 5탭 선택시 페이지를 이동한다는 대전제
  useEffect(function () {
    setToolbarPosition();
    return function () {
      restoreToolbarPosition();
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    id: "bottom-navigation",
    className: "blind"
  }, "\uD398\uC774 \uC11C\uBE44\uC2A4\uBA54\uB274"), /*#__PURE__*/React.createElement("ul", {
    className: cx('article', {
      'is-over-dimmed': isShowModal && _includesInstanceProperty(_context = _Object$values(BOTTOM_MODAL_NOTICE_TYPE)).call(_context, type)
    })
  }, _mapInstanceProperty(ITEMS).call(ITEMS, function (item) {
    var _props$item$type;
    var isSelected = active === item.type;
    var externalProps = props[item.type];
    var serviceProps = NF_SERVICE_INFO[item.type];
    var href = externalProps.href;
    var toolTip = (externalProps === null || externalProps === void 0 ? void 0 : externalProps.toolTip) || null;
    var badge = (_props$item$type = props[item.type]) === null || _props$item$type === void 0 ? void 0 : _props$item$type.badge;
    return /*#__PURE__*/React.createElement("li", {
      key: item.type,
      className: cx('item')
    }, toolTip && ( /*#__PURE__*/React.createElement("div", {
      className: cx('tooltip')
    }, toolTip, /*#__PURE__*/React.createElement("span", {
      className: cx('edge')
    }, /*#__PURE__*/React.createElement(IcTxtArrowDownFill, {
      width: 10,
      height: 5,
      fill: COLOR.darkgray500.color
    })))), /*#__PURE__*/React.createElement(IconText, {
      isSelected: isSelected,
      icon: item.icon,
      badge: badge,
      text: serviceProps.text,
      href: href,
      onClick: function onClick(event) {
        var _externalProps$onClic;
        externalProps === null || externalProps === void 0 || (_externalProps$onClic = externalProps.onClick) === null || _externalProps$onClic === void 0 || _externalProps$onClic.call(externalProps, event);
      }
    }));
  })));
}
function HighLight(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    className: cx('highlight')
  }, children);
}
BottomNavigationBar.HighLight = HighLight;

export { BottomNavigationBar as default };
